import React from "react";
import { Stack, Toggle } from "@fluentui/react";
import { Box, Typography, Grid, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTheme } from "../../../theme/OAS365Theme";
import { useViewCopyStyle } from "../../../theme/styles/ViewCopyStyle";
import { useUploadFilesItem } from "../../../theme/styles/UploadFilesItemStyle";
import ViewCopyDragDropZone from "../../../components/checkinDocuments/ViewCopyDragDropZone";
import ViewCopyRecord from "../../../components/checkinDocuments/ViewCopyRecord";
import {
  AccordionSummaryWithValidation,
  getAccordionSummarySx,
} from "../../../components/checkinDocuments/AccordionSummaryWithValidation";
import { FILE_AUTO_ENABLE, FILE_AUTO_ENABLE_SUB } from "../../../redux/constants/metaData";

/**
 * View Copy accordion: optional auto-generate toggle + drag-drop zone and view copy record.
 */
function ViewCopyAccordionSection({
  expanded,
  onAccordionChange,
  showAutoGenerateToggle,
  createViewCopy,
  onCreateViewCopyChange,
  viewCopyToolTip,
  leftBoxHeight,
  rightBoxHeight,
  hasUploadedFiles,
  uploadBoxHeight,
  isUploadDisabled,
  localViewCopyFileType,
  viewCopyError = "",
}) {
  const theme = useTheme();
  const accordianThemeStyle = useViewCopyStyle();
  const fileStyleTheme = useUploadFilesItem();

  return (
    <Stack.Item grow align="center" style={{ marginTop: "25px", width: "100%" }}>
      <Accordion
        style={accordianThemeStyle.accordianStyle}
        expanded={expanded}
        onChange={onAccordionChange}
        height="43px"
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "#4c8d6a" }} />}
          aria-controls="view-copy-content"
          id="view-copy-header"
          sx={getAccordionSummarySx(!!viewCopyError)}
        >
          <AccordionSummaryWithValidation
            title="View Copy"
            error={viewCopyError}
            titleStyle={accordianThemeStyle.accordianTextStyle}
          />
        </AccordionSummary>
        <AccordionDetails style={accordianThemeStyle.accordianDetails}>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
              alignItems: "stretch",
              flexDirection: "row",
            }}
          >
            {showAutoGenerateToggle && (
              <Box style={accordianThemeStyle.accordianBoxStyle} sx={{ height: leftBoxHeight }}>
                <Box>
                  <Toggle
                    style={{ fontFamily: theme.fonts.regular }}
                    disabled={false}
                    checked={createViewCopy}
                    onChange={(ev, check) => onCreateViewCopyChange(check)}
                    onText={
                      <div
                        style={{
                          fontFamily: theme.fonts.regular,
                          fontSize: theme.fontSizes.normal,
                        }}
                      >
                        {viewCopyToolTip}
                      </div>
                    }
                    offText={
                      <div
                        style={{
                          fontFamily: theme.fonts.regular,
                          fontSize: theme.fontSizes.normal,
                        }}
                      >
                        {viewCopyToolTip}
                      </div>
                    }
                  />
                </Box>
                <Typography style={accordianThemeStyle.viewCopyTextStyle}>
                  {FILE_AUTO_ENABLE}
                  <br />
                  {FILE_AUTO_ENABLE_SUB}
                </Typography>
              </Box>
            )}
            <Box
              sx={{
                width: "100%",
                height: rightBoxHeight,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                <Stack disableShrink style={{ height: "100%" }}>
                  <Stack.Item
                    styles={fileStyleTheme.ViewCopyStackStyle}
                    sx={{
                      flex: hasUploadedFiles ? 0.6 : 1,
                      transition: "flex 0.3s ease",
                      minHeight: uploadBoxHeight,
                    }}
                  >
                    <ViewCopyDragDropZone
                      isDisabled={isUploadDisabled}
                      boxHeight={uploadBoxHeight}
                    />
                  </Stack.Item>
                  {hasUploadedFiles && (
                    <Stack.Item sx={{ flex: 0.4, transition: "flex 0.3s ease" }}>
                      <ViewCopyRecord />
                    </Stack.Item>
                  )}
                </Stack>
              </Box>
            </Box>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Stack.Item>
  );
}

export default ViewCopyAccordionSection;
